import projectService from 'services/project.service';
import { WELL_PROJECT_HISTORY_PAGE_LOADED } from 'features/wells/projects/wellProjects.constants';

export const onLoad = (wellboreId) => (dispatch) =>
  dispatch({
    type: WELL_PROJECT_HISTORY_PAGE_LOADED,
    payload: () => Promise.all([projectService.searchProjects({ wellboreId })]),
  });
